import './PremiumTierIdentity.css';
import type { SessionObject } from '@lub0v/santa-utils';
import { useTranslation } from 'react-i18next';
import { isDotCom } from '@src/site';

export function PremiumAccessSummary({ user }: { user: SessionObject }) {
  const { i18n } = useTranslation();
  const ru = i18n.language.startsWith('ru');
  const f = user.premium?.access.entitlements || user.features;
  const items = [
    (f?.boxThemes || f?.personalThemes) && (ru ? 'Все текущие и будущие темы оформления' : 'All current and future themes'),
    f?.adsDisabled && !isDotCom() && (ru ? 'Без рекламы для вас на всём сайте и для всех участников ваших игр' : 'No ads for you across the site or for anyone in your games'),
    f?.boxDraw && (ru ? 'Расширенное управление жеребьёвкой' : 'Advanced draw controls'),
    f?.boxQuestions && (ru ? 'До 10 своих вопросов' : 'Up to 10 custom questions'),
    f?.boxActivityLog && (ru ? 'История событий игры' : 'Game activity history'),
    f?.boxDomain && (ru ? 'Свой адрес игры' : 'Custom game address'),
    f?.boxMultiOrg && (ru ? 'До 3 организаторов в игре' : 'Up to 3 organizers per game'),
  ].filter(Boolean);
  return <ul className="premium-access-summary" data-testid="premium-access-summary">{items.map(item => <li key={String(item)}>{item}</li>)}</ul>;
}
